export const hasActiveSession = session => !!session.id && !session.isEnded;
export const getSessionWelcomeMessage = session => session.welcomeMessage;

export default {
  hasActiveSession,
  getSessionWelcomeMessage,
};
